import Vue from 'vue';
import './AlertMixin';

Vue.component('AlertProvider', () => import('./AlertProvider.vue'));

interface AlertObject {
  type: 'success' | 'error' | 'warning' | 'info';
  messages: string[];
}

export { AlertObject };
